import { IGetMaterialEmissionFactors } from './types'

// The enum filters the grid's search widens into. functionalUnit is deliberately absent:
// it is a two-value record attribute, not something the free-text search should match on.
export const getMaterialEmissionFactorVars: IGetMaterialEmissionFactors = {
  secondaryDataReferenceSourceType: {
    in: [
      'PrimaryDataFromIndustrySenseChecked',
      'PrimaryDataMeasurementsTakenByMondra',
      'PeerReviewedPublishedLiterature',
      'PublishedBook',
      'IndustryPublishedReport',
      'Ecoinvent',
      'AgriFootPrint',
      'GovernmentFundedOrganizationReport',
      'NonGovernmentalFundedOrganizationReport',
      'Patent',
      'CompanyWebsite',
      'BlogWebsiteForum',
      'OpenSourceWebsite',
      'UndocumentedEstimate',
    ],
  },
  state: {
    in: ['Unpublished', 'Published'],
  },
}
